import _defineProperty from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["styles", "end", "tag", "flip", "modifiers", "placement", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useContext, useMemo } from 'react';
import classNames from 'classnames';
import { Popper } from 'react-popper';
import { applyStylingHoc } from '../../lib/styling.js';
import baseStyles from './Dropdown.scss';
import { DropdownContext } from './Dropdown.js';
var defaultProps = {
  tag: 'div',
  flip: true,
  styles: {}
};
var noFlipModifier = {
  flip: {
    enabled: false
  }
};
var directionPositionMap = {
  up: 'top',
  left: 'left',
  right: 'right',
  down: 'bottom'
};
export var DropdownMenu = function DropdownMenu(props) {
  var styles = props.styles,
      end = props.end,
      Tag = props.tag,
      flip = props.flip,
      modifiers = props.modifiers,
      placement = props.placement,
      children = props.children,
      attrs = _objectWithoutProperties(props, _excluded);

  var context = useContext(DropdownContext);
  var classes = classNames(styles.menu, end && styles['menu-end'], context.isOpen && styles['is-visible']);
  var noFlipModifiers = useMemo(function () {
    return _objectSpread(_objectSpread({}, modifiers), noFlipModifier);
  }, [modifiers]);

  if (context.isOpen && !context.inNavbar) {
    // @ts-ignore
    var position1 = directionPositionMap[context.direction] || 'bottom';
    var position2 = end ? 'start' : 'end';
    return React.createElement(Popper, _objectSpread(_objectSpread({
      tabIndex: "-1",
      role: "menu"
    }, attrs), {}, {
      // @ts-ignore
      placement: "".concat(position1, "-").concat(position2),
      modifiers: !flip ? noFlipModifiers : modifiers,
      "aria-hidden": !context.isOpen,
      className: classes
    }), function (_ref) {
      var ref = _ref.ref,
          placement = _ref.placement,
          arrowProps = _ref.arrowProps,
          style = _ref.style;
      return React.createElement("div", {
        ref: ref,
        className: classes,
        "data-placement": placement,
        style: style
      }, React.createElement("div", {
        ref: arrowProps.ref,
        style: arrowProps.style
      }), children);
    });
  }

  return React.createElement(Tag, _objectSpread(_objectSpread({
    tabIndex: "-1",
    role: "menu"
  }, attrs), {}, {
    placement: placement,
    modifiers: modifiers,
    "aria-hidden": !context.isOpen,
    className: classes
  }), children);
};
DropdownMenu.defaultProps = defaultProps;
export default applyStylingHoc(baseStyles)(DropdownMenu);